<template>
  <div class="sidebar fixed" id="sidebar-fixed">
    <a class="btn btn-default" id="service" target="_blank" @click.prevent.stop="judgeCustomer">
      <strong>
        <i></i>
        <span>客服一</span>
      </strong>
    </a>
    <a class="btn btn-default" href="http://wpa.qq.com/msgrd?v=3&amp;uin=450070586&amp;site=qq&amp;menu=yes" target="_blank">
      <strong>
        <i></i>
        <span>客服二</span>
      </strong>
    </a>
    <router-link class="btn btn-default" :to="{name: 'downloads'}">
      <strong>
        <i></i>
        <span>APP</span>
      </strong>
    </router-link>
    <router-link  class="btn btn-default" id="feedback" :to="{name: 'tutorial'}">
      <strong>
        <i></i>
        <span>教程</span>
      </strong>
    </router-link>
    <a class="btn btn-default top" id="goToTop" title="返回顶部" v-show="scrollTops > 100" @click="backTop">
      <strong>
        <i class="top"></i>
        <span>返回顶部</span>
      </strong>
    </a>
  </div>
</template>

<script>
  import Bus from './eventBus.js'
  import {animate} from '../config/mUtils'
  export default {
    name: 'slideBar',
    data: function () {
      return {
        scrollTops: document.body.scrollTop || document.documentElement.scrollTop
      }
    },
    methods: {
      //判断如果是微信浏览器则先用其他浏览器打开再执行，手机端时，点击客服按钮跳转到QQ聊天界面,如是PC端则跳转到PC端QQ
      judgeCustomer: function () {
        var ua = window.navigator.userAgent.toLowerCase()
        //微信
        if(ua.match(/MicroMessenger/i) === 'micromessenger') {
          if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
            // document.getElementById('weixin-ios').style.display = 'block'
            Bus.$emit('openWeixinIos', true)
          } else if (navigator.userAgent.match(/android/i)) {
            // document.getElementById('weixin-android').style.display = 'block'
            Bus.$emit('openWeixinAndroid', true)
          }
        } else {
          //非微信浏览器
          if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) || navigator.userAgent.match(/android/i)) {
            var mbHref = ['mqqwpa://im/chat?chat_type=wpa&uin=2045403365&version=1&src_type=web&web_src=bjhuli.com']
            var mbHrefLebn = Math.floor(Math.random() * mbHref.length)
            window.open(mbHref[mbHrefLebn])
          } else {
            var pcHref = ['http://wpa.qq.com/msgrd?v=3&uin=2045403365&site=qq&menu=yes']
            var pcHrefLen = Math.floor(Math.random() * pcHref.length)
            window.open(pcHref[pcHrefLen])
          }
        }
      },
      backTop: function () {
        animate(document.documentElement || document.body, {scrollTop: '0'}, 400, 'ease-out')
      },
      handleScroll: function () {
        window.scrollTops = document.body.scrollTop || document.documentElement.scrollTop
        this.scrollTops = window.scrollTops
      }
    },
    mounted: function () {
      var that = this
      window.addEventListener('scroll', that.handleScroll, true)
    },
    //监听滚动条高度
    watch: {
      scrollTops: function (val) {
        this.scrollTops = val
      }
    },
    destroyed: function () {
      window.removeEventListener('scroll', this.handleScroll)
      //  离开页面清除（移除）滚轮滚动事件
    }
  }
</script>

<style scoped>
  /*sidebar fixed*/
  .fixed{
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 1031;
  }
  .sidebar .btn{
    display: block;
    width: 50px;
    height: 45px;
    overflow: hidden;
    border-radius: 4px 0 0 4px;
    margin-bottom: 2px;
    font-size: 12px;
    padding: 0 0 !important;/*!*兼容IE*!*/
  }

  .sidebar .btn-default{
    background-color: #9F9A9A;/*兼容IE*/
    background-color: rgba(158, 154, 154, 0.76);
    border-color: transparent;
  }
  .sidebar .btn:focus,
  .sidebar .btn{
    color: #fff;
  }
  @media (min-width: 768px){
    .sidebar .btn:hover{
      color: #fff;
    }
    .sidebar .btn-default:hover{
      background-color: #C3C3C3;
    }
  }
  .sidebar .btn span{
    padding: 6px 10px;    /*兼容IE*/
    display: block;
    line-height: 30px;
    margin: auto;
    text-align: center;
  }

  .sidebar .top span{
    padding: 6px 8px;
    display: block;
    white-space: normal;
    line-height: 18px;
  }
  .sidebar .top i{
    width: 50px;
    height: 45px;
    background: url('../assets/image/comment/gototop.png') no-repeat;
    display: block;
    line-height: 40px;
    padding-left: 1px;
    margin-top: -1px;
    margin-left: -1px;
    transition: all 300ms ease-out 0s;
  }
  @media (min-width: 768px){
    .sidebar .top:hover i{
      margin-top: -100%;
      transition: all 300ms ease-out 0s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/slideBar.vue